import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from '../hooks/useTranslation';
import { useLanguage } from '../contexts/LanguageContext';
import { withLang } from '../components/LanguageRouter';

const GDPRCompliance = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          {/* Navigation Bar */}
          <div className="mb-6 flex items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-blue-600 hover:text-blue-800 transition-colors duration-200"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              {t('legal.goBack')}
            </button>
            <Link
              to={withLang(currentLanguage)}
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors duration-200"
            >
              <Home className="w-5 h-5 mr-2" />
              {t('footer.home')}
            </Link>
          </div>

          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-4xl font-bold text-blue-900 mb-8">{t('legal.gdpr.title')}</h1>
            <p className="text-gray-600 mb-8">{t('legal.lastUpdated')}</p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.gdpr.section1.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.gdpr.section1.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.gdpr.section2.title')}</h2>
                <div className="bg-blue-50 p-6 rounded-lg">
                  <ul className="space-y-3 text-gray-700">
                    {t('legal.gdpr.section2.rights').map((right, index) => (
                      <li key={index} className="flex items-start">
                        <span className="text-blue-600 mr-2">✓</span>
                        {right}
                      </li>
                    ))}
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.gdpr.section3.title')}</h2>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <p className="text-gray-700 leading-relaxed">
                    {t('legal.gdpr.section3.content')}
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GDPRCompliance;